export {};

$('.graphic-scheme').each(graphicScheme);

function graphicScheme(BlockIndex, Block) {
    let isOpen = false;

    $('.graphic-scheme__box-head').on('click', function onClick(event) {
        const $boxHead = $(event.currentTarget);
        const $box = $boxHead.closest('.graphic-scheme__box');
        const $boxBody = $box.find('.graphic-scheme__box-body');
        const $modalContent = $('<div/>')
            .addClass($box.attr('class'))
            .html($box.html());
        const $modal = $('<div/>')
            .addClass('modal modal--graphic-scheme')
            .append($modalContent);
        const $modalClose = $modal.find('.graphic-scheme__box-toggle');

        $boxBody.filter('.user-text').find('ul').attr(
            "style", "list-style:none!important;list-style-type: none!important;"
        );

        event.preventDefault();

        if (!$boxBody.length) {
            return false;
        }

        const toggleBoxNotMobile = () => {
            $box.toggleClass('graphic-scheme__box--active');

            const isActive = $box.hasClass('graphic-scheme__box--active');

            if (isActive) {
                $boxBody.slideDown(0);
            } else {
                $boxBody.slideUp(0);
            }
        };

        const toggleBoxMobile = () => {
            const openModal = () => {
                $.magnificPopup.open({
                    items: {
                        src: $modal,
                    },
                    ...NLMK.magnificPopupDefaults,
                    showCloseBtn: false,
                    mainClass: 'mfp-graphic-scheme mfp-fade mfp-with-zoom mfp-ajax-gallery',
                    callbacks: {
                        open() {
                            isOpen = true;
                            $modalClose.on('click', function(event) {
                                $.magnificPopup.close();

                                event.preventDefault();
                            });
                        },
                        close() {
                            isOpen = false;
                        },
                        change() {
                            setTimeout(() => {
                                this.content.find('.nano').nanoScroller({ alwaysVisible: true });
                            }, 100);
                        },
                    },
                });
            };

            if ($.magnificPopup.instance.isOpen) {
                $.magnificPopup.close();
                setTimeout(openModal, NLMK.magnificPopupDefaults.zoom.duration);
            } else {
                openModal();
            }
        };

        if (innerWidth < NLMK.mediaQueries.mobile.max) {
            toggleBoxMobile();
        } else {
            toggleBoxNotMobile();
        }
    });

    $(window).on('resize', onResize);

    function onResize() {
        if (innerWidth >= NLMK.mediaQueries.mobile.max && isOpen) {
            $.magnificPopup.close();
        }

        if (innerWidth < NLMK.mediaQueries.mobile.max) {
            if ($(Block).find('.graphic-scheme__box--active').length) {
                $(Block)
                    .find('.graphic-scheme__box--active')
                    .removeClass('graphic-scheme__box--active')
                    .find('.graphic-scheme__box-body')
                    .hide(0);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./js/main/module/graphic-scheme.js